import script from "./BatchIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchIndex.vue?vue&type=script&setup=true&lang=ts"

import "./BatchIndex.vue?vue&type=style&index=0&id=590bc4d6&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590bc4d6"]])

export default __exports__